module.exports = "../../app/cells/components/modals/configure_account/form_cell.rb";